module.exports = "/static/img/data-masters-logo.png?2051b63936d84408fb28bf36bb7ec3be";